import { trackParselyPageView } from 'rest/parsely/client';

export function ParselyPageViewTracking() {
  trackParselyPageView({ location: window.location });
  return null;
}
